import {
  ActionIcon,
  Box,
  Button,
  Divider,
  Drawer,
  Group,
  Input,
  MultiSelect,
  Popover,
  Select,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";

import { ListViewOption } from "core/components/listToggle/listToggleControl";
import { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CSVGenerator, FilterButton, FormInputWrapper } from "core/components";

import { logger } from "utils/logger";
import {
  IconEye,
  IconSearch,
  IconTableExport,
  IconX,
} from "@tabler/icons-react";
import { useRef } from "react";

import {
  DateRanges,
  DateSelections,
  filterSamples,
  generateColKeys,
  getClientLabel,
  getDateRanges,
  pluralize,
  selectItems,
} from "utils/helper";
import { SampleEventType } from "core/models/SampleModel";

import { EmptyState } from "core/components/emptyState/EmptyState";
import { openModal } from "@mantine/modals";

import { useForm } from "@mantine/form";
import CustomDatePicker from "core/components/datePicker/CustomDatePicker";
import moment, { isDate } from "moment";
import {
  fetchStylesByUnit,
  getStylesSuccess,
  selectStyles,
  setWipFilter,
  selectStyle,
  setListColumns,
} from "modules/Distributions/distributionSlice";

import { createColumnHelper } from "@tanstack/react-table";

import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import InfoPanel from "./InfoPanel";
import { WipFilterModel } from "core/models/WipFilterModel";
import { AppConstants, getCompanyTableColumns } from "utils/constants";

import DistributionsCalendar from "./DistributionCalendar";
import DistributionList from "./DistributionList";
import ColumnSelectPopover, { getColumnVisibility } from "core/components/columnSelectPopover/ColumnSelectPopover";
import DateFilterControl from "core/components/dateFilterPanel/DateFilterControl";

var _ = require("lodash");

const Wips = ({
  stylesResult,
  selectedStyles,
  success,
  error,
  setWipFilter,
  wipFilter,
  selectStyles,
  selectStyle,
  selectedStyle,
  listColumns,
  user
}) => {
  const dispatch = useDispatch();
  const [filterOpen, setFilterOpen] = useState(false);
  const [listView, setListView] = useState(ListViewOption.LIST);
  const navigate = useNavigate();
  const location = useLocation();
  // const [selectedItems, setSelectedItems] = useState(selectedStyles);
  const [filterCount, setFilterCount] = useState(0);
  const [wipData, setWipData] = useState(stylesResult.data);
  const [filterItems, setFilterItems] = useState(wipFilter);

  const [isLoading, setIsLoading] = useState(!stylesResult.data.length);

  const [searchParams, setSearchParams] = useSearchParams();
  const [doFetch, setDoFetch] = useState(true);

  const [fetchStatus, setFetchStatus] = useState(null);
  const [opened, { open, close }] = useDisclosure(false);

  const wips = stylesResult.data;
  const theme = useMantineTheme();
  const tabletMatch = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const selectAllMenu = (
    <div>
      <Button
        variant="default"
        onClick={(e) => onMenuItemClick(SampleEventType.SAMPLE_DISTRIBUTE)}
      >
        Distribute
      </Button>
      <Button variant="default" onClick={(e) => onSelectAll(e)}>
        Deselect All
      </Button>
    </div>
  );

  const columns = user?.clientCode?getCompanyTableColumns(user.clientCode,'distributionStyles'):[];
  // Which columns are shown: the user's saved choices over the defaults.
  const columnVisibility = getColumnVisibility(columns, listColumns);


  const filterWips = useCallback(() => {
    var data = filterSamples(wips, wipFilter, columns);

    setWipData(data);
  }, [
    wipFilter.brands,
    wipFilter.categories,
    setWipData,
    wips,
    wipFilter.groupBy,
    wipFilter.keyword,
    wipFilter.departments,
  ]);

  
  /**
   * Effect to handle location change
   */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let displayType = params.get("displayType");

    // set the fetch status so we know what to pass to the criteria
    const status = params.get("status");
    const weekstart = params.get("weekstart");
    const styleNumber = params.get("styleNumber");

    // open the drawer if we have the style
    if (styleNumber) {
      if(styleNumber !== selectedStyle?.styleNumber){
        dispatch(selectStyle(null));
      }
      // dispatch(selectStyle({ id: styleNumber, styleNumber }));
      dispatch(selectStyles([{ id: styleNumber, styleNumber }]));
      open();
    }

    if (fetchStatus !== status) {
      setFetchStatus(status);
    }

    if (weekstart) {
      // add seven days onto the date.
      var startDate = new Date(weekstart);
      startDate.setHours(0, 0, 0, 0);

      var endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 7);
      endDate.setHours(23, 59, 59, 999);

      // if it's past the current date set it today
      const today = getDateRanges({ value: DateRanges.TODAY });
      if (endDate > today.endDate) {
        endDate = today.endDate;
      }

      if (startDate > today.startDate) {
        startDate = today.startDate;
      }
      var item;

      // check if the date is one of the predefined values
      switch (startDate.toDateString()) {
        case getDateRanges({
          value: DateRanges.TODAY,
        }).startDate.toDateString(): {
          item = DateSelections[0];
          break;
        }
        case getDateRanges({
          value: DateRanges.THIS_WEEK,
        }).startDate.toDateString(): {
          item = DateSelections[1];
          break;
        }
        case getDateRanges({
          value: DateRanges.LAST_WEEK,
        }).startDate.toDateString(): {
          item = DateSelections[2];
          break;
        }
        default: {
          var item = DateSelections[3];
          break;
        }
      }

      const dataFilter = {
        ...wipFilter.dataFilter,
        dateRange: {
          item: item,
          value: [startDate, endDate],
        },
      };

      setWipFilter({ ...wipFilter, dataFilter: dataFilter });
    }

    logger.log("location change ", location, " DISPLAY: ", displayType, params);
    // if display type changes
    if (displayType && displayType !== listView) setListView(displayType);
  }, [location, listView]);

  /**
   * Handles the list toggle display
   * @param {*} val
   */
  const listToggleHandler = (val) => {
    navigate({ search: `?displayType=${val}` });
  };

  // Create a debounced version of the search function
  const debouncedSearch = useCallback(
    _.debounce((criteria, dataFilter) => {
      const currentTime = Date.now();
      // Check if item exists and is not expired (e.g., 1 hour = 3600000 ms)
      // has date range changed
      const hasDateRangeChanged = () => {
        const wipStartDate = wipFilter.dataFilter?.dateRange?.value[0];
        const newStartDate = dataFilter?.dateRange?.value[0];

        const wipstartTimestamp =
          wipStartDate != null ? moment(wipStartDate).valueOf() : undefined;
        const newstartTimestamp =
          newStartDate != null ? moment(newStartDate).valueOf() : undefined;

        return wipstartTimestamp !== newstartTimestamp;
      };

      if (
        stylesResult.data &&
        currentTime - stylesResult.timestamp < AppConstants.CACHE_DELAY
        && !hasDateRangeChanged()
      ) {
        // return cachedItem.data;
        setIsLoading(false);
      } else {
        setIsLoading(true);
        dispatch(fetchStylesByUnit(criteria));
      }
    }, 300),
    []
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    let weekstart = params.get("weekstart");

    // set it to this week
    if (!weekstart) {
      // check if we have a dateRange stored in the state if so we use that
      const filterDate = wipFilter.dataFilter?.dateRange?.value[0] ?? null;
      if (filterDate) {
        weekstart = moment(filterDate).format("YYYY-MM-DD");
      } else {
        const startDate = getDateRanges({
          value: DateRanges.THIS_WEEK,
        }).startDate;
        weekstart = moment(startDate).format("YYYY-MM-DD");
      }
    }

    const criteria = {
      status: status,
      //   weekStart: fetchStatus === FetchStatus.DISTRIBUTED ? weekstart : null,
      weekStart: weekstart,
    };

    if (doFetch) {
      debouncedSearch(criteria, wipFilter.dataFilter);
      // we only fetch when date changes
      setDoFetch(false);
    }
  }, [fetchStatus, wipFilter.dataFilter]);

  useEffect(() => {
    logger.log("setting wips, ", wips);
    //setWipData(wips);

    // set the brands/season/category
    var styleNumbers = {};
    var sessions = {};
    var seasons = {};
    var statuses = {};
    var talents = {};
    var issuers = {};
    var depts = {};

    stylesResult?.data?.forEach((item, idx) => {
      styleNumbers[item.styleNumber] = item;
      sessions[item.sessionCode] = item;
      seasons[item.seasonCode] = item;
      statuses[item.status] = item;
      talents[item.talentNames] = item;
      issuers[item.issuer] = item;
      depts[item.dept] = item;
    });

    setFilterItems({
      styleNumbers,
      sessions,
      seasons,
      statuses,
      talents,
      depts,
      issuers,
    });

    filterWips();
  }, [stylesResult.data, filterWips]);

  const onItemClick = (row) => {
    // we need to select the current wip
    // dispatch(selectWip(item));

    // update the route
    // navigate(`/warehouse/wips/${item.wipNumber}`);
    if (row.subRows && row.subRows.length) {
    } else {
      dispatch(selectStyle(row.original));
      // dispatch(selectStyles([row.original]));

      searchParams.set("styleNumber", row.original.styleNumber);
      let urlParms = Object.fromEntries([...searchParams]);
      urlParms.styleNumber = row.original.styleNumber;
      setSearchParams(urlParms);

      // navigate(`/warehouse/wips/${item.wipNumber}`);

      // open();
    }

    logger.log("on item click");
  };

  const onItemSelected = (e, item, selected, rows) => {
    logger.log(item, selectedStyles);

    var items = [...selectedStyles];

    // if the item is a group then push the elements into the group.
    if (item.type && item.type === "group") {
      if (selected) {
        items.push({ id: item.id });
        item.subRows.forEach((row) => {
          var tmpItem = items.find((val) => val.id === row.id);
          if (!tmpItem) items.push({ id: row.id });
        });
      } else {
        _.remove(items, (val) => {
          return val.id === item.id;
        });

        item.subRows.forEach((row) => {
          _.remove(items, (val) => {
            return val.id === row.id;
          });
        });
      }
    } else {
      // var items = [...selectedSeasons];

      // call general helper to select items
      selectItems(
        e,
        item,
        selected,
        rows.map((val) => val.original),
        items
      );
    }
    selectStyles(items);
  };

  const onSelectAll = () => {
    // if there are items selected remove them
    if (selectedStyles.length) {
      //setSelectedItems([])
      dispatch(selectStyles([]));
    } else {
      //setSelectedItems([...elements])
      dispatch(selectStyles([...wipData]));
    }
  };

  const onMenuItemClick = (e) => {
    logger.log(e);
    switch (e) {
      case SampleEventType.SAMPLE_BUILD_OUTFIT: {
        navigate(`/warehouse/outfitter/create`);
        break;
      }
      case SampleEventType.SAMPLE_DISTRIBUTE: {
        openModal({
          title: `New Distribution (${selectedStyles.length})`,
          size: "80%",
          children: (
            <>
              {/* <Distribution selectedItems={selectedStyles.map((val) => wips.find((wip) => wip.id === val.id))} /> */}
            </>
          ),
        });
        break;
      }
      case SampleEventType.SAMPLE_VIEW: {
        onItemClick(e.data);
        break;
      }
      default: {
        break;
      }
    }
  };

  const setFilterVars = (vals) => {
    logger.log(vals);
    setWipFilter(vals);
  };

  useEffect(() => {
    // filter the data.
    filterWips();
  }, [filterWips]);

  const getFilterCount = (val) => {
    var count = 0;
    const dateKeys = ["otbDate", "distribution", "completed"];
    const ignoreKeys = ["groupBy"];
    Object.entries(val).forEach(([key, value]) => {
      if (value && value.length && ignoreKeys.indexOf(key) === -1) {
        ++count;
      }

      if (key === "status") {
        var statusCount = 0;
        Object.entries(value).forEach(([key, value]) => {
          if (value.length) {
            statusCount = 1;
          }
        });

        count += statusCount;
      }

      if (dateKeys.indexOf(key) > -1) {
        if (isDate(value.dateStart) || isDate(value.dateEnd)) {
          ++count;
        }
      }
    });

    return count;
  };

  useEffect(() => {
    const count = getFilterCount(wipFilter);
    setFilterCount(count);
  }, [wipFilter]);

  const onClearClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopPropagation();

    setWipFilter({ ...new WipFilterModel({ groupBy: wipFilter.groupBy }) });

    logger.log("CLEAR CLICK", e);
  };

  const filterButtonHandler = (e) => {
    logger.log("BUTTON CLICK", e, e.nativeEvent);
    setFilterOpen((o) => !o);
  };

  const rowMenuItems = [
    {
      handler: (data) => {
        onItemClick(data);
      },
      label: "View Wip",
      icon: <IconEye size={14} />,
    },
  ];

  useEffect(() => {
    if (success) {
      logger.log("SAMPLE SUCCESS = ", success.type);
      switch (success.type) {
        case getStylesSuccess.toString(): {
          setIsLoading(false);
          break;
        }
        default: {
          break;
        }
      }
    }
  }, [success]);

  const dateRange = wipFilter.dataFilter.dateRange.value;

  return (
    <Box style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Group
        className="main-container-header"
        justify="space-between"
        align="center"
      >
        <Title order={3} lh={"lg"}>
          Distributions
        </Title>

        <Button
          variant="default"
          size="sm"
          leftSection={
            <IconTableExport
              stroke={AppConstants.ICON_STROKE_WIDTH}
              size={AppConstants.ICON_SIZE}
            />
          }
          sx={{ textAlign: "left" }}
          // onClick={(e) => onMenuItemClick(BulkActions.EXPORT)}
        >
          <CSVGenerator
            data={wipData ?? []}
            filename="distribution-export"
            columns={generateColKeys(columns)}
          />
        </Button>
        {/* <ListToggleControl
          value={listView}
          onChange={(val) => listToggleHandler(val)}
          types={[
            {
              label: (
                <Center>
                  <IconList size={16} />
                </Center>
              ),
              value: "list",
            },
            {
              label: (
                <Center>
                  <IconCalendar size={16} />
                </Center>
              ),
              value: "calendar",
            },
          ]}
        /> */}
      </Group>

      <Group
        className="container-action-bar"
        style={{ width: "100%" }}
        justify="space-between"
        height={"100%"}
        py="xs"
      >
        <Group>
          {/* <CheckboxDropdown selectedItems={selectedStyles} onCheckboxClick={onSelectAll} selectMenu={selectAllMenu} /> */}
          <Input
            leftSection={<IconSearch size={AppConstants.ICON_SIZE} />}
            style={{ width: 250 }}
            value={wipFilter.keyword}
            onChange={(e) =>
              setWipFilter({
                ...wipFilter,
                keyword: e.currentTarget.value,
              })
            }
            placeholder={`Search across ${wips.length} ${pluralize(
              "Record",
              wips.length
            )}`}
            rightSectionPointerEvents="all"
            rightSection={
              <ActionIcon
                variant="transparent"
                onClick={() =>
                  setWipFilter({
                    ...wipFilter,
                    keyword: "",
                  })
                }
              >
                {wipFilter.keyword.length ? <IconX size={14} /> : null}
              </ActionIcon>
            }
          />
        </Group>
        <Group>
          {listView !== ListViewOption.CALENDAR ? (
            <DateFilterControl
              filter={wipFilter}
              onApply={() => {
                setDoFetch(true);
              }}
            />
          ) : null}
          <Popover
            shadow="sm"
            opened={filterOpen}
            onChange={setFilterOpen}
            width={tabletMatch ? "100%" : 610}
            withArrow
            closeOnClickOutside={true}
            position="bottom-end"
            // onClose={() => setFilterOpen(false)}
          >
            <Popover.Target>
              <div>
                <FilterButton
                  onClick={filterButtonHandler}
                  onClear={onClearClick}
                  count={filterCount}
                />
              </div>
            </Popover.Target>
            <Popover.Dropdown>
              <div style={{ display: "flex" }}>
                <FilterPanel
                  filter={wipFilter}
                  onCancel={() => setFilterOpen(false)}
                  onApply={(vals) => {
                    setFilterVars(vals);
                    setFilterOpen(false);
                  }}
                  filterItems={filterItems}
                  user={user}
                />
              </div>
            </Popover.Dropdown>
          </Popover>
          {listView === ListViewOption.LIST ? (
            <ColumnSelectPopover
              columns={columns}
              visibility={columnVisibility}
              onChange={(value) => dispatch(setListColumns(value))}
              onReset={() => dispatch(setListColumns(null))}
            />
          ) : null}
          {listView !== ListViewOption.CALENDAR ? (
            <Select
              placeholder="Group By"
              w={230}
              clearable
              value={wipFilter.groupBy}
              onChange={(val) => setWipFilter({ ...wipFilter, groupBy: val })}
              data={[
                { value: "", label: "No Group" },
                { value: "dept", label: "Group by Department" },
                {
                  value: "distributionDate",
                  label: "Group by Distribution Date",
                },
              ]}
            />
          ) : null}
        </Group>
      </Group>

      {/* <ScrollArea wip={{height:500}} > */}
      <Box
        className={
          wipFilter.groupBy && wipFilter.groupBy.length
            ? "main-container-content show-data-grouped"
            : "main-container-content show-data-grouped-hidden"
        }
        style={{ flex: 1, marginBottom: 33, flex: 1, overflow: "hidden" }}
      >
        {listView === ListViewOption.LIST ? (
          <div className="table-wrapper" style={{ position: "relative" }}>
            <DistributionList
              user={user}
              loading={isLoading}
              data={wipData}
              originalData={wips}
              onItemClick={onItemClick}
              onMenuItemClick={onMenuItemClick}
              onItemSelected={onItemSelected}
              selectedItems={selectedStyles}
              filter={wipFilter}
              actionMenu={rowMenuItems}
              columns={columns}
              columnVisibility={columnVisibility}
              setFilter={setWipFilter}
            />

            {wipData && wipData.length === 0 && !isLoading ? (
              <Box
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  top: 200,
                }}
              >
                <EmptyState />
              </Box>
            ) : null}

            {/* <TestList wipData={wips} /> */}
          </div>
        ) : (
          //     <SampleList
          //         loading={isLoading}
          //         data={wipData}
          //         onItemClick={onItemClick}
          //         onMenuItemClick={onMenuItemClick}
          //         onItemSelected={onItemSelected}
          //         selectedItems={selectedStyles}
          //         filter={wipFilter}
          //         actionMenu={rowMenuItems}
          //         columns={[
          //             {
          //                 // Build our expander column
          //                 id: 'expander', // Make sure it has an ID
          //                 Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
          //                     <>
          //                         {/* <span {...getToggleAllRowsExpandedProps()}>
          //   {isAllRowsExpanded ? <IconChevronDown /> : <IconChevronRight />}
          // </span> */}
          //                     </>
          //                 ),
          //                 Cell: ({ row }) =>
          //                     // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
          //                     // to build the toggle for expanding a row
          //                     row.canExpand ? (
          //                         <span
          //                             {...row.getToggleRowExpandedProps({
          //                                 wip: {
          //                                     // We can even use the row.depth property
          //                                     // and paddingLeft to indicate the depth
          //                                     // of the row
          //                                     paddingLeft: `${row.depth * 2}rem`,
          //                                 },
          //                             })}>
          //                             {row.isExpanded ? <IconChevronDown /> : <IconChevronRight />}
          //                         </span>
          //                     ) : null,
          //             },
          //             {
          //                 Header: 'Photo Code',
          //                 accessor: 'photoCode',
          //             },
          //             {
          //                 Header: 'Wip',
          //                 accessor: 'wipNumber',
          //             },
          //             {
          //                 Header: 'Status',
          //                 accessor: 'status',
          //             },
          //             {
          //                 Header: 'Name',
          //                 accessor: 'name',
          //             },
          //             {
          //                 Header: 'Event',
          //                 accessor: 'seasonCode',
          //             },
          //             {
          //                 Header: 'Session',
          //                 accessor: 'sessionCode',
          //             },
          //             {
          //                 Header: 'Department',
          //                 accessor: 'dept',
          //             },
          //             {
          //                 Header: 'OTB Date',
          //                 accessor: 'otbDate',
          //                 sortType: (a, b) => headerDateSort(a, b, 'otbDate'),
          //             },
          //             {
          //                 Header: 'Completed',
          //                 accessor: 'completed',
          //                 sortType: (a, b) => headerDateSort(a, b, 'completed'),
          //             },
          //             {
          //                 Header: 'Dist Date',
          //                 accessor: 'distributionDate',
          //                 sortType: (a, b) => headerDateSort(a, b, 'distributionDate'),
          //             },
          //             {
          //                 Header: 'Issuer',
          //                 accessor: 'issuer',
          //                 width: 200,
          //             },
          //             {
          //                 Header: '',
          //                 accessor: 'action',
          //                 width: 50,
          //             },
          //             //   ],
          //             // },
          //         ]}
          //         setFilter={setWipFilter}
          //     />
          // <WipGrid
          //     data={wipData}
          //     onItemClick={onItemClick}
          //     onItemSelected={onItemSelected}
          //     selectedItems={selectedStyles}
          // />
          <>
            <DistributionsCalendar styles={wipData} />
          </>
        )}
      </Box>
      {/* </ScrollArea> */}

      <Drawer
        id="drawer"
        opened={opened}
        closeOnEscape={false}
        trapFocus={true}
        onClose={() => {
          let urlParms = Object.fromEntries([...searchParams]);
          delete urlParms.styleNumber;
          setSearchParams(urlParms);
          close();
        }}
        title="Quick Style View"
        position="right"
      >
        {/* Drawer content */}
        <InfoPanel selectedItem={selectedStyle} opened={opened} user={user} />
      </Drawer>
    </Box>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    wipFilter: state.distributionReducer.wipFilter,
    selectedStyles: state.distributionReducer.selectedStyles,
    selectedStyle: state.distributionReducer.selectedStyle,
    wip: state.distributionReducer.selectedWip,
    stylesResult: state.distributionReducer.styles,
    success: state.distributionReducer.success,
    displayPrefs: state.distributionReducer.displayPrefs,
    listColumns: state.distributionReducer.listColumns,
    error: state.distributionReducer.error,
  };
};

const mapDispatchToProps = { setWipFilter, selectStyles, selectStyle };

export default connect(mapStateToProps, mapDispatchToProps)(Wips);

const FilterPanel = ({ onCancel, onApply, filter, filterItems, user }) => {
  logger.log(" FILTER PANEL", filter, filterItems);
  const form = useForm({
    initialValues: {
      ...filter,
      completed: {
        dateStart: filter.completed?.dateStart?.toString().length
          ? moment(filter.completed?.dateStart).toDate()
          : "",
        dateEnd: filter.completed?.dateEnd?.toString().length
          ? moment(filter.completed?.dateEnd).toDate()
          : "",
      },
      otbDate: {
        dateStart: filter.otbDate?.dateStart?.toString().length
          ? moment(filter.otbDate?.dateStart).toDate()
          : "",
        dateEnd: filter.otbDate?.dateEnd?.toString().length
          ? moment(filter.otbDate?.dateEnd).toDate()
          : "",
      },
      distribution: {
        dateStart: filter.distribution?.dateStart?.toString().length
          ? moment(filter.distribution?.dateStart).toDate()
          : "",
        dateEnd: filter.distribution?.dateEnd?.toString().length
          ? moment(filter.distribution?.dateEnd).toDate()
          : "",
      },
      // status:{
      //     sampleCount:filter.status.sampleCount.toString(),
      //     photographyCount:filter.status.photographyCount.toString(),
      //     taskCount:filter.status.taskCount.toString(),
      //     taskCompletedCount:filter.status.taskCompletedCount.toString()
      // }
    },
  });

  // useEffect(() => {
  //   if (filter && form) {
  //     form.setValues({ ...filter });
  //   }
  // }, [filter]);

  const getFilterVars = useCallback(
    (key) => {
      var res = [];
      if (filterItems[key])
        Object.keys(filterItems[key]).forEach((val) => res.push(val));
      return res.sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true })
      );
    },
    [filter, filterItems]
  );

  return (
    <Box shadow="xs" style={{ width: "100%" }} className="filter-panel">
      <form onSubmit={form.onSubmit((values) => onApply(values))}>
        {/* <ScrollArea wip={{ overflowX: "hidden" }}> */}
        <Box>
          <FormInputWrapper label="Styles" labelWidth={"120px"}>
            <MultiSelect
              data={getFilterVars("styleNumbers")}
              label=""
              placeholder="Pick all that you like"
              searchable
              comboboxProps={{ withinPortal: false }}
              // nothingFound="Nothing found"
              {...form.getInputProps("styleNumbers")}
            />
          </FormInputWrapper>

          <FormInputWrapper label="Department" labelWidth={"120px"}>
            <MultiSelect
              data={getFilterVars("depts")}
              label=""
              placeholder="Pick all that you like"
              searchable
              comboboxProps={{ withinPortal: false }}
              // nothingFound="Nothing found"
              {...form.getInputProps("departments")}
            />
          </FormInputWrapper>

          <FormInputWrapper
            label={getClientLabel(user.clientCode, 'otbDate')}
            id="input-otbDate"
            labelWidth={"120px"}
          >
            <Group wrap={"nowrap"}>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder={`From ${getClientLabel(user.clientCode, 'otbDate')}`}
                {...form.getInputProps("otbDate.dateStart")}
              />
              <Text>to</Text>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder={`To ${getClientLabel(user.clientCode, 'otbDate')}`}
                {...form.getInputProps("otbDate.dateEnd")}
              />
            </Group>
          </FormInputWrapper>

          {/* <FormInputWrapper
            label="Completed Date"
            id="input-completed"
            labelWidth={"120px"}
          >
            <Group wrap={"nowrap"}>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="From Completed Date"
                {...form.getInputProps("completed.dateStart")}
              />
              <Text>to</Text>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="To Completed Date"
                {...form.getInputProps("completed.dateEnd")}
              />
            </Group>
          </FormInputWrapper> */}

          <FormInputWrapper
            label="Distribution Date"
            id="input-completed"
            labelWidth={"120px"}
          >
            <Group wrap={"nowrap"}>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="From Distribution Date"
                {...form.getInputProps("distribution.dateStart")}
              />
              <Text>to</Text>
              <CustomDatePicker
                sx={{ width: 190 }}
                placeholder="To Distribution Date"
                {...form.getInputProps("distribution.dateEnd")}
              />
            </Group>
          </FormInputWrapper>
        </Box>
        {/* </ScrollArea> */}
        <Divider />
        <Group justify="space-between" mt="lg">
          <Button
            variant="subtle"
            component="button"
            size="sm"
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <Button type="submit" size="sm" variant="filled">
            Apply
          </Button>
        </Group>
      </form>
    </Box>
  );
};

// COLUMN DECLARATION
const columnHelper = createColumnHelper();
const columnsStatic = [
  columnHelper.accessor("styleNumber", {
    header: "Style Number",
    cell: (info) => info.getValue(),
    size: 180,
  }),

  columnHelper.accessor("name", {
    header: "Name",
    cell: (info) => info.getValue(),
    size: 300,
  }),
  columnHelper.accessor("distributionDate", {
    header: "Distribution Date",
    cell: (info) => info.getValue(),
    size: 200,
  }),
  columnHelper.accessor("dept", {
    header: "Department",
    cell: (info) => info.getValue(),
    size: 180,
  }),
  columnHelper.accessor("otbDate", {
    header: "OTB Date",
    cell: (info) => info.getValue(),
  }),
];
